<template>
</template>

<script>
  const userdata ={} ; 
  const islogin =false ; 
  function add(a,b) {
    return a+ b
  }
  export default { 
    userdata,
    islogin, 
  }
</script>

<style>
</style>
